"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = registerSync;
function registerSync() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var syncReadyHandler = p.syncReadyHandler,
    syncReject = p.syncReject;
  if ("serviceWorker" in navigator && "SyncManager" in window) {
    navigator.serviceWorker.ready.then(function (reg) {
      if (syncReadyHandler) {
        return syncReadyHandler({
          reg: reg
        });
      }
      return null;
    })["catch"](function (err) {
      if (syncReject) {
        return syncReject({
          err: err
        });
      }
    });
  } else {
    if (syncReject) {
      return syncReject();
    }
  }
}